<template>
    <b-tabs>
        <b-tab
            title="OKRs"
            @click="onChangeTab(tabs.okr)"
            :active="selectedTab === tabs.okr"
            v-if="permissions.canViewOKR"
        >
            <daily v-if="selectedTab === tabs.okr" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.initiatives')"
            @click="onChangeTab(tabs.myInitiatives)"
            :active="selectedTab === tabs.myInitiatives"
            v-if="permissions.canViewInitiatives"
            button-id="btn-profile-okr-tab-my-initiatives"
        >
            <my-initiatives v-if="selectedTab === tabs.myInitiatives" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.targets')"
            @click="onChangeTab(tabs.targets)"
            :active="selectedTab === tabs.targets"
            v-if="permissions.canViewTarget"
        >
            <targets :user="user" v-if="selectedTab === tabs.targets" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.focalPoint')"
            @click="onChangeTab(tabs.focalPoint)"
            :active="selectedTab === tabs.focalPoint"
            v-if="permissions.canViewTarget && isToShowSomeTabs.focalPoint"
        >
            <targets :user="user" :periodIds="periods" :type="'focal-points'" v-if="selectedTab === tabs.focalPoint" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.hiringGoals')"
            @click="onChangeTab(tabs.hiringGoals)"
            :active="selectedTab === tabs.hiringGoals"
            v-if="permissions.canViewTarget && isToShowSomeTabs.hiringGoals"
        >
            <targets
                :user="user"
                :periodIds="periods"
                :type="'library-goals'"
                v-if="selectedTab === tabs.hiringGoals"
            />
        </b-tab>
        <b-tab
            id="home-values-tab"
            :title="$t('profile.tabs.values')"
            @click="onChangeTab(tabs.values)"
            :active="selectedTab === tabs.values"
            v-if="permissions.canViewValues"
        >
            <evaluations-results :user="user" :periodIds="periods" v-if="selectedTab === tabs.values" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.pdi')"
            @click="onChangeTab(tabs.pdi)"
            :active="selectedTab === tabs.pdi"
            v-if="permissions.canViewPDI"
        >
            <pdi :user="user" :periodIds="periods" v-if="selectedTab === tabs.pdi" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.careerObjective')"
            @click="onChangeTab(tabs.careerObjective)"
            :active="selectedTab === tabs.careerObjective"
            v-if="permissions.canViewCareerObjectives"
        >
            <career-objective :user="user" v-if="selectedTab === tabs.careerObjective" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.miniCurriculum')"
            @click="onChangeTab(tabs.miniCurriculum)"
            :active="selectedTab === tabs.miniCurriculum"
            v-if="permissions.canViewMiniCurriculum"
        >
            <mini-curriculum />
        </b-tab>
        <b-tab :title="$t('profile.tabs.feed')" :active="selectedTab === tabs.feed" @click="onChangeTab(tabs.feed)">
            <feed :userID="user.id" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.subordinates')"
            @click="onChangeTab(tabs.subordinates)"
            :active="selectedTab === tabs.subordinates"
            v-if="permissions.canViewSubordinates && isToShowSomeTabs.subordinates"
        >
            <subordinates :user="user" />
        </b-tab>
        <b-tab
            :title="$t('profile.tabs.comment')"
            @click="onChangeTab(tabs.comment)"
            :active="selectedTab === tabs.comment"
            v-if="permissions.canViewComments"
        >
            <general-comment :user="user" :periodIds="periods" v-if="selectedTab === tabs.comment" />
        </b-tab>
    </b-tabs>
</template>

<script>
import {
    PDI,
    Feed,
    Subordinates,
    MiniCurriculum,
    CareerObjective,
    Targets,
    GeneralComment,
    EvaluationsResults,
    MyInitiatives,
    Daily,
} from '../components'

const tabs = {
    okr: 'okr',
    myInitiatives: 'myInitiatives',
    targets: 'targets',
    hiringGoals: 'hiringGoals',
    focalPoint: 'focalPoint',
    feed: 'feed',
    subordinates: 'subordinates',
    values: 'values',
    careerObjective: 'careerObjective',
    pdi: 'pdi',
    miniCurriculum: 'miniCurriculum',
    comment: 'comment',
}

const getTabsPriority = (context) => [
    {
        tab: tabs.okr,
        permission: context.permissions.canViewOKR,
    },
    {
        tab: tabs.myInitiatives,
        permission: context.permissions.canViewInitiatives,
    },
    {
        tab: tabs.targets,
        permission: context.permissions.canViewTarget,
    },
    {
        tab: tabs.values,
        permission: context.permissions.canViewValues,
    },
    {
        tab: tabs.pdi,
        permission: context.permissions.canViewPDI,
    },
    {
        tab: tabs.careerObjective,
        permission: context.permissions.canViewCareerObjectives,
    },
    {
        tab: tabs.miniCurriculum,
        permission: context.permissions.canViewMiniCurriculum,
    },
    {
        tab: tabs.feed,
        permission: true,
    },
]

export default {
    name: 'Tabs',
    components: {
        Feed,
        Targets,
        pdi: PDI,
        Subordinates,
        GeneralComment,
        MiniCurriculum,
        CareerObjective,
        EvaluationsResults,
        MyInitiatives,
        Daily,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        periods: {
            type: Array,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        isToShowSomeTabs: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tabs: tabs,
            selectedTab: null,
        }
    },
    watch: {
        '$route.query.activeTab': {
            handler: function (activeTab) {
                if (activeTab) {
                    this.onChangeTab(activeTab)
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        if (!this.isThereAnActiveTab()) {
            this.getFirstAllowedTabToSetAsTheDefaultTab()
        }
    },
    methods: {
        onChangeTab(tab) {
            this.selectedTab = tab
            this.$router.push({ query: { activeTab: tab } })
        },
        isThereAnActiveTab() {
            return this.$route.query.activeTab
        },
        getFirstAllowedTabToSetAsTheDefaultTab() {
            const tabsPriority = getTabsPriority(this)
            this.onChangeTab(tabsPriority.find((t) => t.permission).tab)
        },
    },
}
</script>
